module.exports = __webpack_public_path__ + "img/globalIcon2.53c44a5c.png";